import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Page } from '../models';

export type DecisionNotificationType =
  'NEW_DECISION' |
  'COUNTDOWN' |
  'REMINDER';

export type DecisionNotificationStatus =
  'SENT' |
  'FAILED' |
  'SKIPPED';

export interface DecisionNotificationHistory {
  id: number;
  decisionId: number;
  decisionName: string;
  commercialId: number;
  commercialName: string;
  customerId: number;
  customerName: string;
  type: DecisionNotificationType;
  title: string;
  message: string;
  decisionDate: string;
  status: DecisionNotificationStatus;
  firebaseMessageId: string;
  createdAt: string;
  sentAt: string;
  errorMessage: string;
}

export interface DecisionNotificationHistoryStatistics {
  total: number;
  sent: number;
  failed: number;
  skipped: number;
}

@Injectable()
export class DecisionNotificationHistoryService {

  notificationUrl =
    environment.dns + 'api/decision-notifications/';

  constructor(private http: HttpClient) {
  }

  getHistory(
    page: number,
    size: number,
    startDate?: Date,
    endDate?: Date
  ): Observable<Page<DecisionNotificationHistory>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    params = this.addPeriodParams(
      params,
      startDate,
      endDate
    );

    return this.http.get<Page<DecisionNotificationHistory>>(
      this.notificationUrl + 'history',
      { params }
    );
  }

  getStatistics(
    startDate?: Date,
    endDate?: Date
  ): Observable<DecisionNotificationHistoryStatistics> {
    let params = new HttpParams();

    params = this.addPeriodParams(
      params,
      startDate,
      endDate
    );

    return this.http.get<DecisionNotificationHistoryStatistics>(
      this.notificationUrl + 'history/statistics',
      { params }
    );
  }

  private addPeriodParams(
    params: HttpParams,
    startDate?: Date,
    endDate?: Date
  ): HttpParams {
    if (startDate) {
      params = params.set(
        'startDate',
        this.formatRequestDate(startDate)
      );
    }

    if (endDate) {
      params = params.set(
        'endDate',
        this.formatRequestDate(endDate)
      );
    }

    return params;
  }

  private formatRequestDate(date: Date): string {
    const year = date.getFullYear();
    const month =
      ('0' + (date.getMonth() + 1)).slice(-2);
    const day =
      ('0' + date.getDate()).slice(-2);

    return year + '-' + month + '-' + day;
  }
}
